import { useEffect, useState } from "react";

const links = [
  { href: "#focus", label: "焦点旧料" },
  { href: "#zones", label: "分类考古" },
  { href: "#timeline", label: "年代编年" },
  { href: "#deep", label: "专题盘点" },
  { href: "#hot", label: "翻旧账热榜" },
  { href: "#faq", label: "阅读须知" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={
        "sticky top-0 z-50 transition-colors duration-300 " +
        (scrolled || open
          ? "bg-background-50/90 backdrop-blur border-b border-background-200"
          : "bg-background-50")
      }
    >
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex h-16 md:h-20 items-center justify-between gap-4">
          {/* 品牌 */}
          <a href="#top" className="flex items-center gap-3 shrink-0">
            <span className="flex h-9 w-9 md:h-10 md:w-10 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-archive-stack-line text-xl" />
            </span>
            <span className="leading-none">
              <span className="block font-heading text-lg md:text-xl font-bold tracking-wide text-foreground-950">
                全网黑料
              </span>
              <span className="mt-1 block text-[11px] tracking-[0.2em] text-foreground-500">
                旧料考古档案
              </span>
            </span>
          </a>

          {/* 桌面导航 */}
          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <span className="flex items-center gap-1.5 text-xs text-secondary-700 bg-secondary-100 px-3 py-1.5 rounded-full whitespace-nowrap">
              <i className="ri-live-line" />
              今日补档 · 持续更新
            </span>
            <a
              href="#cta"
              className="inline-flex items-center gap-2 rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-background-50 hover:bg-primary-700 whitespace-nowrap"
            >
              <i className="ri-chat-follow-up-line" />
              报料线索
            </a>
          </div>

          {/* 移动端开关 */}
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden flex h-10 w-10 items-center justify-center rounded-md bg-background-100 text-foreground-800"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {/* 移动端菜单 */}
      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2">
          <div className="grid grid-cols-2 gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
          </div>
          <a
            href="#cta"
            onClick={() => setOpen(false)}
            className="mt-3 flex items-center justify-center gap-2 rounded-md bg-primary-600 px-4 py-2.5 text-sm font-semibold text-background-50"
          >
            <i className="ri-chat-follow-up-line" />
            报料线索
          </a>
        </div>
      )}
    </header>
  );
}